import { render, staticRenderFns } from "./PopUp.vue?vue&type=template&id=e4f182e6"
import script from "./PopUp.vue?vue&type=script&lang=ts"
export * from "./PopUp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports